import { render, staticRenderFns } from "./addRecords.vue?vue&type=template&id=6871cb24&scoped=true"
import script from "./addRecords.vue?vue&type=script&lang=js"
export * from "./addRecords.vue?vue&type=script&lang=js"
import style0 from "./addRecords.vue?vue&type=style&index=0&id=6871cb24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6871cb24",
  null
  
)

export default component.exports